import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormHeaderDirective } from '@portal-core/general/directives/form/form-header/form-header.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FormHeaderDirective
  ],
  exports: [
    FormHeaderDirective
  ]
})
export class FormHeaderModule { }
